import React from "react";
import CandidateFilterBody from "../../../../utils/CandidateFilterBody";
import { ChevronIcon, FilterIcon, SearchIcon } from "../icons";

// Left "Advanced Search" filter panel. `cv` is the useCandidatesV2() result.
const AdvancedSearchSidebar = ({ cv }) => {
  const {
    searchTerm, isDisabled, filtersChanged,
    filterItems, filterConfigLoaded, openAccordions, subitemsData, loadingAccordion, loadingMoreMap,
    filterValues, chipCountByKey, skillsMatchMode, handleSkillsModeChange,
    handleSearch, handleApplyFilters, handleOpenSaveSearch, handleOpenSavedSearches, toggleAccordion,
    handleCheckbox, handlePill, handleRange, handleStageScore, handleStageStatus, handleResponse,
    handleSubitemSearch, handleSubitemLoadMore,
  } = cv;

  return (
    <aside className="candidates-v2-sidebar">
      <div className="sidebar-header-v2">
        {/* Title row + Apply button */}
        <div className="sidebar-header-top-row">
          <div className="sidebar-title-v2">
            <FilterIcon />
            <span>Advanced Search</span>
          </div>
          <button
            className={`apply-filters-btn-v2${filtersChanged ? " active" : ""}`}
            onClick={handleApplyFilters}
            disabled={!filtersChanged || isDisabled}
          >
            Apply
          </button>
        </div>

        {/* Save search / Saved searches row */}
        <div className="sidebar-search-links-row">
          <button className="sidebar-link-btn-v2" onClick={handleOpenSaveSearch} disabled={isDisabled}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" />
            </svg>
            Save search
          </button>
          <button className="sidebar-link-btn-v2" onClick={handleOpenSavedSearches} disabled={isDisabled}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
            </svg>
            Saved
          </button>
        </div>
      </div>

      <div className="sidebar-accordion-v2">
        {filterItems.length === 0 && !filterConfigLoaded && (
          <div className="acc-loading-msg">Loading filters…</div>
        )}
        {filterItems.map((item) => {
          const isItemOpen = openAccordions.has(item.key);
          const isSearch = item.key === "search";
          const countBadge = isSearch ? (searchTerm ? 1 : 0) : (chipCountByKey[item.key] || 0);
          const isLoading = loadingAccordion[item.key];
          return (
            <div key={item.key} className={`acc-item-v2 ${isItemOpen ? "open" : ""} ${!item.enabled ? "acc-disabled" : ""}`}>
              <button
                type="button"
                className="acc-btn-v2"
                onClick={() => toggleAccordion(item.key, item.enabled !== false)}
                disabled={item.enabled === false}
              >
                <span className="acc-btn-left">
                  <span>{item.label}</span>
                  {item.badge && <span className="acc-soon-badge">{item.badge}</span>}
                  {countBadge > 0 && <span className="filter-badge">{countBadge}</span>}
                </span>
                {item.key === "skills" && item.enabled !== false && (
                  <span className="skills-match-toggle-v2" onClick={(e) => e.stopPropagation()}>
                    <span role="button" tabIndex={0} className={`skills-mode-btn-v2${skillsMatchMode === "all" ? " active" : ""}`} onClick={() => handleSkillsModeChange("all")}>AND</span>
                    <span role="button" tabIndex={0} className={`skills-mode-btn-v2${skillsMatchMode === "any" ? " active" : ""}`} onClick={() => handleSkillsModeChange("any")}>OR</span>
                  </span>
                )}
                <ChevronIcon open={isItemOpen} />
              </button>
              {isItemOpen && (
                <div className="acc-body-v2">
                  {isSearch ? (
                    <div className="sidebar-search-v2">
                      <SearchIcon />
                      <input type="text" placeholder="Search name or phone..." value={searchTerm} onChange={handleSearch} />
                    </div>
                  ) : isLoading ? (
                    <div className="filter-acc-loading">
                      <div className="spinner-border" style={{ width: "1rem", height: "1rem", color: "#F75891" }} />
                    </div>
                  ) : (
                    <CandidateFilterBody
                      filterKey={item.key}
                      data={subitemsData[item.key]}
                      filterValues={filterValues}
                      onCheckbox={handleCheckbox}
                      onPill={handlePill}
                      onRange={handleRange}
                      onStageScore={handleStageScore}
                      onStageStatus={handleStageStatus}
                      onResponse={handleResponse}
                      onSearch={handleSubitemSearch}
                      onLoadMore={handleSubitemLoadMore}
                      loadingMore={!!loadingMoreMap[item.key]}
                      skillsMatchMode={skillsMatchMode}
                      onSkillsModeChange={handleSkillsModeChange}
                    />
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </aside>
  );
};

export default AdvancedSearchSidebar;
